import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setTradeIn } from '../actions'
import Colors from './Colors'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeIn: state.tradeIn,
  configuration: state.configuration
})

const mapDispatchToProps = {
  setWizards,
  setTradeIn
}

export default connect(mapStateToProps, mapDispatchToProps)(Colors)
